import { Card, Grid } from "@mui/material";
import { ReactNode, useEffect, useMemo, useState } from "react";

import Box from "../../components/Box";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import Stepper from "../../components/Stepper";
import useStrings from "../../hooks/useStrings";
import Typography from "../../components/Typography";
import GroupStep from "../../components/Organization/stepGroup";
import StaffStep from "../../components/Organization/stepStaff";
import useContainerOrganization from "../../hooks/useContainerOrganization";
import BasicInformationStep from "../../components/Organization/stepBasicInfo";

import { MainComponent } from "../main";
import { Mode, OrganizationType } from "../../constants/enums";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { ICodename, ILableOrganization, IMultiLanguageContent, IPropDetailContainer } from "../../commons/interfaces";



//
type IProps = IPropDetailContainer & ILableOrganization & {
    title?: string,
    newDomain?: string,

    hidenStatus?: boolean,
    hidenActionUpdate?: boolean,
    hidenActionCreate?: boolean,
    showActionSpecifyOwner?: boolean,
    validateActionSpecifyOwner?: boolean,

    hidenActionUpdateStaff?: boolean,
    hidenActionDeleteStaff?: boolean,
    hidenActionCreateStaff?: boolean,
    hidenActionInvationStaff?: boolean,
    hidenActionDeleteStaffAllService?: boolean,

    hidenActionDeleteGroup?: boolean,
    hidenActionUpdateGroup?: boolean,
    hidenActionCreateGroup?: boolean,
    hidenInputSelectGroupParent?: boolean,
    requiredInputSelectGroupParent?: boolean,

    stepChildrens?: {
        label: string;
        children: ReactNode | JSX.Element;
    }[];

    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;

    modalUpdateMember?: (props: {
        groupId?: string;
        organizationId: string;
        idDetailStaff?: string;

        dataRoles?: ICodename[];
        dataGroups?: ICodename[];

        visibleModal: boolean
        setVisibleModal: React.Dispatch<React.SetStateAction<boolean>>

        onCallBack?: () => void
    }) => JSX.Element;
    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;
    onUpdateListOrganization: (props: {
        data: ICodename[],
        isFetchUserInfo: boolean
    }) => Promise<any>;
}

const OrganizationEditContainer = ({
    mode,
    title,
    idDetail,
    newDomain,
    lableGroup,
    lableStaff,
    lableOrganization,

    hidenStatus,
    hidenActionUpdate,
    hidenActionCreate,
    showActionSpecifyOwner,
    validateActionSpecifyOwner,

    hidenActionUpdateStaff,
    hidenActionDeleteStaff,
    hidenActionCreateStaff,
    hidenActionInvationStaff,
    hidenActionDeleteStaffAllService,

    hidenActionDeleteGroup,
    hidenActionUpdateGroup,
    hidenActionCreateGroup,
    hidenInputSelectGroupParent,
    requiredInputSelectGroupParent,

    stepChildrens,

    onGoBack,
    onChangeMode,
    modalCreateMember,
    modalUpdateMember,
    modalInvitationMember,
    onUpdateListOrganization,
}: IProps) => {

    const strings = useStrings();

    const {
        language,
        userInfo,
    } = useCommonComponentContext();

    const {
        dataRoles,
        dataGroups,
        dataUserTitle,
        dataGroupByOrg,
        dataStaffByOrg,
        idGroupDefaultByOrg,

        isOnChange,
        dataOwnerOrg,
        dataDetailOrg,
        errorDetailOrg,
        valMultilanguage,
        handleChangeOwner,
        setValMultiLanguage,
        handleChangeLanguage,
        handleChangeValueDataDetailOrganization,

        getDataOrther,
        getDetailOrganization,
        onCreateUpdateOrganization,

    } = useContainerOrganization();

    const modeScreen = useMemo(() => mode, [mode]);

    const newLableOrganization = useMemo(() => (
        (lableOrganization || strings.Common.ORGANIZATION)
    ), [lableOrganization, strings]);

    const newLableStaff = useMemo(() => (
        (lableStaff || strings.Common.STAFF)
    ), [lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (lableGroup || strings.Common.GROUP)
    ), [lableGroup, strings]);

    const [activeStep, setActiveStep] = useState(1);
    const [stepLabels, setStepLabels] = useState<string[]>([newLableOrganization, newLableGroup, newLableStaff]);

    const newValueShowActionSpecifyOwner = useMemo(() => {
        if (showActionSpecifyOwner) {
            const itemOrg = userInfo?.listOrganization?.find(el => (
                `${el.code}` === userInfo?.userProfile?.organizationId &&
                (Number(el.detail?.type) === OrganizationType.Main)
            ));

            const valueReturn = validateActionSpecifyOwner ? !Helpers.isNullOrEmpty(itemOrg) : true;

            return valueReturn;
        } else {
            return false;
        }
    }, [
        userInfo?.userProfile?.organizationId,
        userInfo?.listOrganization,
        showActionSpecifyOwner,
        validateActionSpecifyOwner,
    ]);

    useEffect(() => { setValMultiLanguage(language); }, [language]);

    useEffect(() => {
        setStepLabels([newLableOrganization, newLableGroup, newLableStaff]);
    }, [newLableOrganization, newLableGroup, newLableStaff]);

    useEffect(() => {
        if (hidenActionUpdate) {
            onChangeMode(Mode.View);
        }
    }, [hidenActionUpdate]);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(idDetail)) {
            getDetailOrganization(idDetail);
        }
    }, [idDetail]);

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(dataDetailOrg?.id)) {

            getDataOrther(dataDetailOrg?.id);

            let labelTemp: string[] = [newLableOrganization];

            if (dataDetailOrg?.isAdmin === true || dataDetailOrg?.isOwner === true) {
                labelTemp = [newLableOrganization, newLableGroup, newLableStaff];
            } else {
                if (!hidenActionDeleteGroup || !hidenActionCreateGroup || !hidenActionUpdateGroup) {
                    labelTemp.push(newLableGroup);
                }
                if (!hidenActionCreateStaff || !hidenActionUpdateStaff || !hidenActionDeleteStaff) {
                    labelTemp.push(newLableStaff);
                }
            }

            const newLabel = [...stepChildrens || []].map(el => el.label);

            labelTemp = [...labelTemp || [], ...newLabel || []];

            setStepLabels(labelTemp);

        }
    }, [dataDetailOrg?.id, stepChildrens]);

    const handleUpdateListOrganization = (props: {
        isCreate: boolean,
        dataDetail: {
            id: string,
            gene: string,
            code?: string,
            name: IMultiLanguageContent,
        }
    }) => {
        let listOrgTemp = [...userInfo?.listOrganization || []];

        if (props.isCreate) {
            listOrgTemp.push({
                code: props.dataDetail?.id,
                name: Helpers.renderValueByLanguage({ data: props.dataDetail?.name, currentLanguage: language }) || "",
                detail: {
                    groups: [],
                    isCollapse: false,
                    gene: props.dataDetail?.gene,
                    organizationCode: props.dataDetail?.code,
                }
            });
        } else {
            const index = listOrgTemp.findIndex((el) => el.code === props.dataDetail?.id);
            if (index !== -1) {
                listOrgTemp[index] = {
                    ...listOrgTemp[index],
                    name: Helpers.renderValueByLanguage({ data: props.dataDetail?.name, currentLanguage: language }) || "",
                };
            }
        }

        onUpdateListOrganization({ data: listOrgTemp, isFetchUserInfo: false });
    }

    const onBackPress = () => {
        if (activeStep === 1) {
            if (isOnChange === false) {
                onGoBack();
            } else {
                Helpers.showConfirmAlert(strings.Common.CANCEL_ACTION_MESSAGE, onGoBack);
            }
        } else {
            setActiveStep(activeStep - 1);
        }
    };

    const onSubmit = () => {
        onCreateUpdateOrganization({
            newLableOrg: newLableOrganization,
            onCallBack: async (newData) => {
                if (Helpers.isNullOrEmpty(dataDetailOrg?.id)) {
                    await handleUpdateListOrganization({
                        isCreate: true,
                        dataDetail: newData
                    });

                    await getDetailOrganization(newData?.id);

                    setActiveStep(2);
                } else {
                    await handleUpdateListOrganization({
                        isCreate: false,
                        dataDetail: newData
                    });

                    await getDetailOrganization(newData?.id);

                    onChangeMode(Mode.View);
                }
            },
        });
    }

    const renderTabContent = () => {
        const isPermission = newValueShowActionSpecifyOwner || (dataDetailOrg?.isAdmin === true || dataDetailOrg?.isOwner === true);

        const newStepChildrens = [...stepChildrens || []].map(el => el.children);

        const newListChildrens = [
            (
                <BasicInformationStep
                    lableStaff={lableStaff}
                    lableGroup={lableGroup}
                    lableOrganization={lableOrganization}

                    mode={modeScreen}
                    language={valMultilanguage}
                    dataOwnerOrg={dataOwnerOrg}
                    dataDetailOrg={dataDetailOrg}
                    errorDetailOrg={errorDetailOrg}

                    hidenStatus={hidenStatus}
                    handleChangeOwner={() => {
                        handleChangeOwner(newLableOrganization)
                    }}
                    handleChangeLanguage={handleChangeLanguage}
                    handleChangeValue={handleChangeValueDataDetailOrganization}

                    showActionSpecifyOwner={newValueShowActionSpecifyOwner}
                />
            ),
            (
                <Card>
                    <GroupStep
                        lableStaff={lableStaff}
                        lableGroup={lableGroup}
                        lableOrganization={lableOrganization}

                        hidenInputSelectGroupParent={hidenInputSelectGroupParent}
                        hidenActionCreate={hidenActionCreateGroup || !isPermission}
                        hidenActionUpdate={hidenActionUpdateGroup || !isPermission}
                        hidenActionDelete={hidenActionDeleteGroup || !isPermission}
                        requiredInputSelectGroupParent={requiredInputSelectGroupParent}

                        mode={modeScreen}
                        dataRowByGroup={dataGroupByOrg}
                        groupIdDefault={idGroupDefaultByOrg}
                        organizationId={dataDetailOrg?.id || "0"}

                        onCallBack={() => {
                            getDetailOrganization(dataDetailOrg?.id);
                        }}
                    />
                </Card>
            ),
            (
                <Card>
                    <StaffStep
                        newDomain={newDomain}

                        lableStaff={lableStaff}
                        lableGroup={lableGroup}
                        lableOrganization={lableOrganization}

                        hidenActionInvation={hidenActionInvationStaff}
                        hidenActionCreate={hidenActionCreateStaff || !isPermission}
                        hidenActionUpdate={hidenActionUpdateStaff || !isPermission}
                        hidenActionDelete={hidenActionDeleteStaff || !isPermission}
                        hidenActionDeleteAllService={hidenActionDeleteStaffAllService}

                        mode={modeScreen}
                        dataRoles={dataRoles}
                        dataGroups={dataGroups}
                        dataUserTitle={dataUserTitle}
                        dataRowByStaff={dataStaffByOrg}
                        idGroupDefaultByOrg={idGroupDefaultByOrg}
                        organizationId={dataDetailOrg?.id || "0"}

                        modalCreateMember={modalCreateMember}
                        modalUpdateMember={modalUpdateMember}
                        modalInvitationMember={modalInvitationMember}

                        onCallBack={() => {
                            getDetailOrganization(dataDetailOrg?.id);
                        }}
                    />
                </Card>
            ),
            ...newStepChildrens || [],
        ];

        return newListChildrens[activeStep - 1] || null;
    };

    const valueBackground = "linear-gradient(195deg, rgb(73, 163, 241), rgb(26, 115, 232)) !important";

    return (
        <MainComponent>
            <Grid container>
                <Grid item xs={12}>
                    <Box sx={{
                        mb: 2,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "flex-end",
                        justifyContent: !Helpers.isNullOrEmpty(title) ? "space-between" : "end",
                    }}>
                        {
                            !Helpers.isNullOrEmpty(title) &&
                            <Typography variant="h5">{title}</Typography>
                        }

                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "flex-end",
                        }}>
                            <Button color="secondary" onClick={onBackPress}>
                                {strings.Common.GO_BACK}
                            </Button>
                            {
                                !Helpers.isNullOrEmpty(dataDetailOrg?.id) &&
                                <Button
                                    color="info"
                                    sx={{ background: valueBackground }}
                                    disabled={!(activeStep < stepLabels.length)}
                                    onClick={() => {
                                        setActiveStep(activeStep + 1);
                                    }}
                                >
                                    {strings.Common.NEXT}
                                </Button>
                            }
                            {(modeScreen === Mode.View) && !hidenActionUpdate &&
                                <Button onClick={() => { onChangeMode(Mode.Update); }}>
                                    {strings.Common.EDIT}
                                </Button>
                            }
                            {(modeScreen === Mode.Update) && !hidenActionUpdate && (activeStep === 1) &&
                                <Button onClick={onSubmit}>
                                    {strings.Common.SAVE}
                                </Button>
                            }
                            {(modeScreen === Mode.Create) && !hidenActionCreate && (activeStep === 1) &&
                                <Button onClick={onSubmit}>
                                    {strings.Common.SAVE}
                                </Button>
                            }
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <div style={{ width: "100%" }}>
                        {
                            (stepLabels.length > 1) &&
                            <Card square>
                                <Box width={"100%"} p={2}>
                                    <Stepper
                                        hidenSequency
                                        stepLabels={stepLabels}
                                        activeStep={(activeStep - 1)}
                                        onStepChange={setActiveStep}
                                        canChangeStep={!Helpers.isNullOrEmpty(dataDetailOrg?.id)}
                                    />
                                </Box>
                            </Card>
                        }
                        <Box mt={3}>
                            {renderTabContent()}
                        </Box>
                    </div>
                </Grid>
            </Grid>
        </MainComponent>
    );
};

export default OrganizationEditContainer;
